import { render } from "./overFormComponent.vue?vue&type=template&id=6084c017&scoped=true"
import script from "./overFormComponent.vue?vue&type=script&lang=js"
export * from "./overFormComponent.vue?vue&type=script&lang=js"

import "./overFormComponent.vue?vue&type=style&index=0&id=6084c017&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6084c017"]])

export default __exports__